export const fleets = [
  'CA-Brave',
  'CA-Desktop',
  'CA-Tor',
  'MD-Brave',
  'MD-Desktop',
  'MD-Phone-AppOnly',
  'VA-Android',
  'VA-Desktop',
]

export const startFleets = [
  'CA-Brave',
  'CA-Desktop',
  'CA-Tor',
  'MD-Brave',
  'MD-Desktop',
  'MD-Phone-AppOnly',
  // 'VA-Android',
  // 'VA-Desktop',
  // 'VA-TEST-Tor-Elastic',
]

export const appstreamOptions = [
  {
    bonfireId: 'CADesktop',
    ApplicationId: 'Desktop',
    FleetName: 'CA-Desktop' /* required */,
    StackName: 'VPC-CA-Desktop' /* required */,
  },
  {
    bonfireId: 'MDDesktop',
    ApplicationId: 'Desktop',
    FleetName: 'MD-Desktop' /* required */,
    StackName: 'VPC-MD-Desktop' /* required */,
  },
  {
    bonfireId: 'VADesktop',
    ApplicationId: 'Desktop',
    FleetName: 'VA-Desktop' /* required */,
    StackName: 'VPC-VA-Desktop' /* required */,
  },
  {
    bonfireId: 'VAAndroid',
    ApplicationId: 'Android',
    FleetName: 'VA-Android' /* required */,
    StackName: 'VPC-VA-Android' /* required */,
  },
  {
    bonfireId: 'MDAndroid',
    ApplicationId: 'Android',
    FleetName: 'MD-Phone-AppOnly' /* required */,
    StackName: 'VPC-MD-Android' /* required */,
  },
  {
    bonfireId: 'BraveMD',
    ApplicationId: 'Brave',
    FleetName: 'MD-Brave' /* required */,
    StackName: 'VPC-MD-Brave' /* required */,
  },
  {
    bonfireId: 'TorCA',
    ApplicationId: 'Android',
    FleetName: 'CA-Tor' /* required */,
    StackName: 'VPC-CA-TOR' /* required */,
  },
  {
    bonfireId: 'TorMD',
    ApplicationId: 'TOR',
    FleetName: 'MD-TOR' /* required */,
    StackName: 'VPC-MD-TOR' /* required */,
  },
  {
    bonfireId: 'BraveCA',
    ApplicationId: 'Brave',
    FleetName: 'CA-Brave' /* required */,
    StackName: 'VPC-CA-Brave' /* required */,
  },
  {
    bonfireId: 'BraveVAElastic',
    ApplicationId: 'AWS-Test-2',
    FleetName: 'VA-Brave-Elastic' /* required */,
    StackName: 'VPC-VA-Brave-Elastic' /* required */,
  },
  {
    bonfireId: 'BraveMDElastic',
    ApplicationId: 'AWS-Test-2',
    FleetName: 'MD-Brave-Elastic' /* required */,
    StackName: 'VPC-MD-Brave-Elastic' /* required */,
  },
  {
    bonfireId: 'BraveCAElastic',
    ApplicationId: 'AWS-Test-2',
    FleetName: 'LA-Brave-Elastic' /* required */,
    StackName: 'VPC-LA-Brave-Elastic' /* required */,
  },
  {
    bonfireId: 'AndroidMDElastic',
    ApplicationId: 'MD-Android',
    FleetName: 'MD-Android-Elastic' /* required */,
    StackName: 'VPC-MD-Android-Elastic' /* required */,
  },
  {
    bonfireId: 'AndroidLAElastic',
    ApplicationId: 'LA-Android-V4',
    FleetName: 'LA-Android-Elastic' /* required */,
    StackName: 'VPC-LA-Android-Elastic' /* required */,
  },
  {
    bonfireId: 'MDTorElastic',
    ApplicationId: 'elastictorapplication',
    FleetName: 'ElasticTorMD' /* required */,
    StackName: 'ElasticTorMd' /* required */,
  },
  {
    bonfireId: 'LA-Tor-Elastic',
    ApplicationId: 'elastictorapplication',
    FleetName: 'LA-Tor-Elastic' /* required */,
    StackName: 'LA-Tor-Elastic' /* required */,
  },
  {
    bonfireId: 'VA-Tor-Elastic',
    ApplicationId: 'elastictorapplication',
    FleetName: 'VA-Tor-Elastic' /* required */,
    StackName: 'LA-Tor-Elastic' /* required */,
  },
  {
    bonfireId: 'VA-TEST-Tor-Elastic',
    ApplicationId: 'Desktop',
    FleetName: 'VA-TEST-Tor-Elastic' /* required */,
    StackName: 'VPC-VA-TEST-Tor-Elastic' /* required */,
  },
  {
    bonfireId: 'BigVM-MD',
    ApplicationId: 'Desktop',
    FleetName: 'BigVM-MD' /* required */,
    StackName: 'BigVM-MD-Test' /* required */,
  },
  {
    bonfireId: 'BigVM-CA',
    ApplicationId: 'Desktop',
    FleetName: 'BigVM-CA' /* required */,
    StackName: 'BigVM-CA' /* required */,
  },
  {
    bonfireId: 'VA_BRAVE_E',
    ApplicationId: 'Desktop',
    FleetName: 'VA_BRAVE_E' /* required */,
    StackName: 'VA_BRAVE_E' /* required */,
  },
  {
    bonfireId: 'va-elastic-brave-big-vm',
    ApplicationId: 'Desktop',
    FleetName: 'va-elastic-brave-big-vm' /* required */,
    StackName: 'va-elastic-brave-big-vm' /* required */,
  },
  {
    bonfireId: 'NOLA-Brave-E',
    ApplicationId: 'Desktop',
    FleetName: 'NOLA-Brave-E' /* required */,
    StackName: 'NOLA-Brave-E' /* required */,
  },
]
